export default function subCategoryReducer(state, action) {
  //console.log('STATE  : ', state)
  switch (action.type) {
    case 'GET_ALL_SUBCATEGORIES':
      return {
        ...state,
        subcategories: action.payload,
        loading: false,
      }
    case 'ADD_SUBCATEGORY':
      return {
        ...state,
        subcategories: [action.payload, ...state.subcategories],
      }
    case 'EDIT_SUBCATEGORY':
      const updatedSubCategory = action.payload

      const updatedSubCategories = state.subcategories.map((subCategory) => {
        if (subCategory._id === updatedSubCategory._id) {
          return updatedSubCategory
        }
        return subCategory
      })

      return {
        ...state,
        subcategories: updatedSubCategories,
      }
    case 'REMOVE_SUBCATEGORY':
      return {
        ...state,
        subcategories: state.subcategories.filter((subcategory) => subcategory._id !== action.payload),
      }
    default:
      return state
  }
}
